import React from 'react';
import PropTypes from 'prop-types';

import QuestionErrorMessage from '../QuestionErrorMessage';
import DesktopRatingQuestionControl from './DesktopRatingQuestionControl';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

const RatingFormField = ({
  shouldHandleError = true,
  startFromZero = false,
  ratingIconList,
  className,
  ratingClassName,
  segmentClassName,
  ratingItemClassName,
  indexClassName,
  readOnly,
  segmentLabelList,
  shouldHidePersonalIndex = {},
  itemListCount,
  block,
  block: { personalLabelType },
  styling,
  meta,
  input: { onChange, value },
}) => (
  <div className={className}>
    {shouldHandleError && <QuestionErrorMessage fieldMeta={meta} />}
    <DesktopRatingQuestionControl
      count={itemListCount}
      segmentLabelList={segmentLabelList}
      personalLabelType={personalLabelType}
      iconList={ratingIconList}
      value={value}
      block={block}
      readOnly={readOnly}
      onChange={onChange}
      max={startFromZero ? itemListCount - 1 : itemListCount}
      min={startFromZero ? -1 : 0} // "-1" do the job for sending zero values - ReactRating issue @sinslav
      ratingItemClassName={ratingItemClassName}
      controlClassName={ratingClassName}
      segmentClassName={segmentClassName}
      indexClassName={indexClassName}
      shouldHidePersonalIndex={shouldHidePersonalIndex.desktop}
      styling={styling}
    />
  </div>
);

RatingFormField.propTypes = {
  meta: PropTypes.object,
  input: PropTypes.object,
  segmentLabelList: PropTypes.array,
  ratingIconList: PropTypes.object,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  segmentClassName: PropTypes.string,
  ratingClassName: PropTypes.string,
  indexClassName: PropTypes.string,
  startFromZero: PropTypes.bool,
  shouldHandleError: PropTypes.bool,
  shouldHidePersonalIndex: PropTypes.shape({
    mobile: PropTypes.bool,
    desktop: PropTypes.bool,
  }),
  itemListCount: PropTypes.number,
  ratingItemClassName: PropTypes.string,
  block: PropTypes.shape({
    required: PropTypes.bool,
    shape: PropTypes.string.isRequired,
    color: PropTypes.string,
    personalLabelType: PropTypes.string,
  }).isRequired,
  styling: propTypeBlockStyling,
};

export default RatingFormField;
